
export enum EventPrivacyMode {
    Public = 'Public',
    Private = 'Private',
    Internal = 'Internal',
}
